import * as React from "react";
import "../styles.css";
import Swal from "sweetalert2";
import { RedStar } from "./RedStar";
import ReactTooltip from "react-tooltip";
import { Tooltip } from "./Tooltip";
import {
  getQueryParam,
  getToken,
  validateSignedUrl,
} from "../utilityFunctions";

interface Iprops {
  endpoint: string;
  spinnerTimeOut: number;
}

interface IState {
  currentStep: number;
  formData: IFormData;
  applicationCanceled: boolean;
  loading: boolean;
  countryList: any[];
  tenantData: any;
  formAccepted: boolean;
  token: string;
  error: boolean;
  signedLink: string;
  isLoading: boolean;
  taxTreatyError: string;
  errorText: string;
  errorMessage: string;
}
interface IFormData {
  CountryOfResidence: string;
  ClaimingProvisions: string;
  WithholdingClaimPercentageRate: string;
  TypeOfIncome: string;
  AdditionalConditions: string;
  TaxTreaty: boolean;
}

export class W8Ben extends React.Component<Iprops, IState> {
  state: IState;
  constructor(props: Iprops) {
    super(props);
    this.state = {
      currentStep: 0,
      formData: {
        CountryOfResidence: "",
        ClaimingProvisions: "",
        WithholdingClaimPercentageRate: "",
        TypeOfIncome: "",
        AdditionalConditions: "",
        TaxTreaty: false,
      },
      formAccepted: false,
      applicationCanceled: false,
      loading: false,
      countryList: [],
      tenantData: {
        supportEmail: "#####@#####.com",
        supportNumber: "### ### ####",
      },
      token: "",
      error: false,
      signedLink: "",
      isLoading: true,
      taxTreatyError: "",
      errorText: "",
      errorMessage: "",
    };

    this.validateToken = this.validateToken.bind(this);
  }

  componentDidMount() {
    const url = getQueryParam("url");
    validateSignedUrl(url).then((response) => {
      if (response.status !== 200) {
        this.setState({
          error: true,
          errorMessage: response.body.Message,
        });
      }
    });

    const token = getToken();
    this.setState({ token: token });
    this.validateToken(token);
  }

  renderError = () => {
    return <div>There was an error... {this.state.errorMessage}</div>;
  };

  validateToken(token: string) {
    this.setState({ loading: true });

    fetch(this.props.endpoint + "/DocumentData/W8form/MetaData/" + token)
      .then((response: any) => {
        return response.json();
      })
      .then((res: any) => {
        const data = {
          supportEmail: res.Data.BrokerEmail,
          supportNumber: res.Data.BrokerSupportContact,
          clientName: res.Data.ClientName,
        };

        var countries = res.Data.Countries.sort((x: any, y: any) =>
          x.IsoAlpha2 === "ZA" ? -1 : y.IsoAlpha2 === "ZA" ? 1 : 0
        );

        this.setState({
          loading: false,
          tenantData: {
            ...data,
          },
          countryList: countries,
        });
      })
      .catch((err: any) => {
        this.setState({
          error: true,
          loading: false,
          errorMessage: "Token has timed out!",
        });
      });
  }

  handleChange = (field: string, e: any) => {
    const { formData } = this.state;

    let newData = { ...formData };
    this.setState({ taxTreatyError: "", errorText: "", errorMessage: "" });

    if (field === "WithholdingClaimPercentageRate") {
      if (Number(e.target.value) > 100) {
        newData.WithholdingClaimPercentageRate = "100";
      } else if (Number(e.target.value) < 0) {
        newData.WithholdingClaimPercentageRate = "0";
      } else {
        newData.WithholdingClaimPercentageRate = e.target.value;
      }
    } else {
      (newData as any)[field] = e.target.value;
    }

    this.setState({ formData: newData });
  };

  next = () => {
    this.setState({ currentStep: this.state.currentStep + 1 });
    window.scrollTo({ top: 0 });
  };

  back = () => {
    this.setState({ currentStep: this.state.currentStep - 1 });
    window.scrollTo({ top: 0 });
  };

  cancel = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Are you sure you want to cancel your W-8BEN form submission?",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      reverseButtons: true,
      buttonsStyling: false,
      focusConfirm: false,
      focusCancel: false,
      width: "30%",
      padding: "50px",
      imageUrl: "./public/icons/cancel.svg",
      imageWidth: 100,
      imageHeight: 100,
      imageAlt: "",
      customClass: {
        content: "popup-title",
        confirmButton: "btn-solid",
        cancelButton: "btn-clear",
        image: "cancel-icon",
      },
    }).then((result: any) => {
      if (result.value) {
        this.setState({ applicationCanceled: true });
      }
    });
  };

  valCheckStep1 = () => {
    const { formData } = this.state;

    if (!formData.TaxTreaty) {
      if (formData.CountryOfResidence.length < 1) {
        this.setState({
          taxTreatyError: "Please select country of residence",
          errorText: "countryError",
          errorMessage: "errorLabel",
        });
      } else {
        this.submitStep1();
      }
    } else {
      this.submitStep1();
    }
  };

  submitStep1 = () => {
    const { formData } = this.state;

    this.setState({ loading: true });

    const data = {
      ...formData,
      Id: this.state.token,
    };

    const options = {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
      },
    };

    fetch(this.props.endpoint + "/DocumentData/W8form", options)
      .then((res: any) => {
        if (res.status !== 200) {
          this.setState({
            error: true,
            loading: false,
            taxTreatyError: "",
            errorText: "",
            errorMessage: "",
          });
        } else {
          this.setState({
            loading: false,
            taxTreatyError: "",
            errorText: "",
            errorMessage: "",
          });
          this.next();
        }
      })
      .catch((_: any) => {
        this.setState({
          error: true,
          loading: false,
          taxTreatyError: "",
          errorText: "",
          errorMessage: "",
        });
      });
  };

  submitStep2 = () => {
    this.setState({ loading: true });

    fetch(
      this.props.endpoint +
        `/DocumentData/W8form/PDF/${this.state.token}/Approve`
    )
      .then((_: any) => {
        this.setState({ loading: false });
        this.next();
        setTimeout(() => {
          this.setState({ isLoading: false });
        }, this.props.spinnerTimeOut);
      })
      .catch((_: any) => {
        this.setState({ error: true, loading: false });
      });
  };

  acceptForm = () => {
    this.setState({
      formAccepted: !this.state.formAccepted,
    });
  };

  openPdf = () => {
    Swal.fire({
      position: "top",
      width: "90%",
      html: `<div><object style="width: 100%; height: 85vh" data='${this.props.endpoint}/DocumentData/W8form/PDF/${this.state.token}#toolbar=0' type="application/pdf"/></div>`,
    });
  };

  renderFormStep(): any {
    const { currentStep } = this.state;
    switch (currentStep) {
      case 0:
        return this.renderStep1();
      case 1:
        return this.renderStep2();
      case 2:
        return this.renderStep3();
      default:
        return null;
    }
  }

  getApprovedDownloadLink = () => {
    fetch(
      this.props.endpoint +
        "/DocumentData/W8form/PDF/Approved/" +
        this.state.token
    )
      .then((res: any) => {
        return res.json();
      })
      .then((response: any) => {
        var a: any = document.getElementById("download-link");
        a.href = response.Message;
        a.target = "_blank";
        a.click();
      })
      .catch((_: any) => {
        alert("Download link not available, please try again.");
      });
  };

  renderCancelPage() {
    return (
      <div className="cancel-container">
        <div className="application-canceled-icon" />

        <div className="cancel-title">Application Cancelled</div>

        <br />
        <div>
          Your W-8BEN application has been cancelled and won't be submitted.
        </div>
        <br />
        <div>
          Should you want to re-apply, simply revisit the provided sign-on link.
        </div>
        <br />
        <br />
      </div>
    );
  }

  renderWizardSteps() {
    const { currentStep } = this.state;

    return (
      <div className="wizard-container">
        <div className={`wizard-step${currentStep >= 0 ? "-highlighted" : ""}`}>
          <div>{currentStep > 0 ? <span className="wizard-check" /> : 1}</div>
          <span>Inputs</span>
        </div>
        <div className={`wizard-step${currentStep >= 1 ? "-highlighted" : ""}`}>
          <div>{currentStep > 1 ? <span className="wizard-check" /> : 2}</div>
          <span>Declaration</span>
        </div>
        <div className={`wizard-step${currentStep >= 2 ? "-highlighted" : ""}`}>
          <div>{currentStep > 2 ? <span className="wizard-check" /> : 3}</div>
          <span>Complete</span>
        </div>
      </div>
    );
  }

  renderCountryDropdowns() {
    return this.state.countryList.map((country: any, index: number) => {
      return (
        <option key={index} value={country.IsoAlpha2}>
          {country.Name}
        </option>
      );
    });
  }

  handleTaxTreatyChange = () => {
    this.setState((prevState) => {
      const newState = { ...prevState };
      newState.formData.TaxTreaty = !newState.formData.TaxTreaty;
      newState.taxTreatyError = "";
      newState.errorText = "";
      newState.errorMessage = "";
      return newState;
    });
  };

  renderStep1() {
    return (
      <div>
        <ReactTooltip />
        <div className="step-title">Claim Tax Treaty Benefits</div>
        <hr />
        <div className="step-content">
          <div style={{ textAlign: "center" }}>
            <br />
            You have recently requested to trade offshore equities. As part of
            your registration, we kindly request that you complete and submit
            the W-8BEN form for the IRS.
            <br />
            The form allows you to document your foreign status and/or claim tax
            treaty benefits on any US-listed equities.
            <br />
            <br />
            To assist you with this process, we have populated the form with
            your credentials we have on record.
            <br />
            If you would like to claim tax treaty benefits, please first
            complete the relevant details below.
            <br />
            <br />
            <hr />
          </div>

          <div className="heading">
            Claim of Tax Treaty Benefits (see{" "}
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.irs.gov/pub/irs-pdf/iw8ben.pdf"
            >
              instructions
            </a>{" "}
            - Part II)
          </div>

          <div>
            <span>I certify that the beneficial owner is a resident of </span>

            <select
              disabled={this.state.formData.TaxTreaty}
              onChange={(e) => this.handleChange("CountryOfResidence", e)}
              value={this.state.formData.CountryOfResidence}
              className={this.state.errorText}
            >
              <option value="" defaultValue="true">
                {" "}
                Please Select{" "}
              </option>
              {this.renderCountryDropdowns()}
            </select>
            {!this.state.formData.TaxTreaty ? <RedStar /> : ""}
            <Tooltip
              symbol="?"
              message={
                "Only countries that have treaties with the IRS are listed here. If you choose not to make a treaty claim and/or are not eligible to make a treaty claim, please check the checkbox below"
              }
            />
            <span>
              {" "}
              within the meaning of the income tax treaty between the United
              States and that country.
            </span>
            <br />
            <br />
            <span>
              <strong>
                <input
                  type="checkbox"
                  checked={this.state.formData.TaxTreaty}
                  disabled={this.state.formData.CountryOfResidence.length > 0}
                  onChange={() => this.handleTaxTreatyChange()}
                />
                I choose not to make a treaty claim and/or I am not eligible to
                make a treaty claim.
              </strong>
            </span>
          </div>

          <div>
            <br />
            <span>
              <strong>Only complete if applicable: </strong>If special rates and
              conditions apply (see{" "}
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.irs.gov/pub/irs-pdf/iw8ben.pdf"
              >
                instructions
              </a>{" "}
              part II line 10):{" "}
            </span>
            <span>
              <br />
              The beneficial owner is claiming the provisions of Article and
              paragraph
            </span>
            <span>
              <input
                onChange={(e) => this.handleChange("ClaimingProvisions", e)}
                value={this.state.formData.ClaimingProvisions}
              />{" "}
              of the treaty identified on line 9 above to claim a{" "}
              <input
                onChange={(e) =>
                  this.handleChange("WithholdingClaimPercentageRate", e)
                }
                value={this.state.formData.WithholdingClaimPercentageRate}
                type="number"
                min="0"
                max="100"
              />
            </span>
            <span>
              {" "}
              % rate of withholding on (specify type of income):
              <br />
              <br />
            </span>
            <div>
              <span className="full-width">
                <input
                  onChange={(e) => this.handleChange("TypeOfIncome", e)}
                  value={this.state.formData.TypeOfIncome}
                />
                <br />
                <br />
              </span>
            </div>
            <div>
              <span>
                <strong>Only complete if applicable: </strong> Explain the
                additional conditions in the Article and paragraph the
                beneficial owner meets to be eligible for the rate of
                witholding:
              </span>
            </div>
            <div>
              <span className="full-width">
                <textarea
                  onChange={(e) => this.handleChange("AdditionalConditions", e)}
                  value={this.state.formData.AdditionalConditions}
                />
                <br />
                <br />
              </span>
            </div>
          </div>
          <span className={this.state.errorMessage}>
            {this.state.taxTreatyError}
          </span>

          <hr />

          <div className="btn-container">
            <button onClick={this.cancel} className="btn-clear">
              Cancel
            </button>
            <button onClick={this.valCheckStep1} className="btn-solid">
              Next
            </button>
          </div>
        </div>
      </div>
    );
  }

  renderStep2() {
    return (
      <div>
        <div className="step-title">Review and verify your W-8BEN form</div>
        <hr />
        <div className="step-content">
          <div style={{ textAlign: "center" }}>
            <br />
            Please review and verify that your details are correct by clicking
            the button below to access your completed W-8BEN form.
            <br />
            Once reviewed, please agree to the certification below by accepting
            the terms of the IRS.
            <div style={{ width: "100%", margin: "20px auto" }}>
              <div
                className="btn-solid pdfBtn"
                style={{ width: "22%", textAlign: "center", margin: "0 auto" }}
                onClick={this.openPdf}
              >
                {" "}
                View your W-8BEN form{" "}
              </div>
            </div>
            <div>
              If you have any queries, feel free to contact our support desk on{" "}
              <strong>{this.state.tenantData.supportNumber}</strong> or via
              email{" "}
              <strong>
                <a href={`mailto:${this.state.tenantData.supportEmail}`}>
                  {this.state.tenantData.supportEmail}
                </a>
              </strong>
            </div>
            <br />
          </div>

          <hr />

          <div className="heading">
            <strong>Certification</strong>
          </div>

          <div>
            Under penalties of perjury, I declare that I have examined the
            information on this form and to the best of my knowledge and belief
            it is true, correct, and complete. I further certify under penalties
            of perjury that:
          </div>
          <br />
          <div>
            <ul>
              <div>
                <li>
                  I am the individual that is the beneficial owner (or am
                  authorized to sign for the individual that is the beneficial
                  owner) of all the income to which this form relates or am
                  using this form to document myself for chapter 4 purposes,
                </li>
              </div>
              <div>
                <li>
                  The person named on line 1 of this form is not a U.S. person,
                </li>
              </div>
              <div>
                <li>
                  The income to which this form relates is:
                  <ul>
                    <li>
                      {" "}
                      (a) not effectively connected with the conduct of a trade
                      or business in the United States,
                    </li>
                    <li>
                      {" "}
                      (b) effectively connected but is not subject to tax under
                      an applicable income tax treaty, or
                    </li>
                    <li>
                      {" "}
                      (c) the partner's share of a partnership's effectively
                      connected income,
                    </li>
                  </ul>
                </li>
              </div>
              <div>
                <li>
                  The person named on line 1 of this form is a resident of the
                  treaty country listed on line 9 of the form (if any) within
                  the meaning of the income tax treaty between the United States
                  and that country, and
                </li>
              </div>
              <div>
                <li>
                  For broker transactions or barter exchanges, the beneficial
                  owner is and exempt foreign person as defined in the
                  instructions.
                </li>
              </div>
            </ul>
          </div>
          <div>
            Furthermore, I authorize this form to be provided to any withholding
            agent that has control receipt or custody of the income of which I
            am the beneficial owner or any withholding agent that can disburse
            or make payments of the income of which I am the beneficial owner.{" "}
            <strong>
              I agree that I will submit a new form within 30 days if any
              certificiation made on this form becomes incorrect.
            </strong>
          </div>

          <div>
            <br />

            <label className="checkbox">
              By checking this box, I,{" "}
              <strong>{this.state.tenantData.clientName}</strong>, certify that,
              to the best of my knowledge, the information submitted above is
              accurate and complete.
              <input
                type="checkbox"
                value={String(this.state.formAccepted)}
                onChange={this.acceptForm}
              />
              <span className="checkmark" />
            </label>
          </div>
          <br />
          <hr />
          <div className="btn-container">
            <button onClick={this.cancel} className="btn-clear">
              Cancel
            </button>
            <button className="btn-clear" onClick={this.back}>
              Back
            </button>
            <button
              disabled={!this.state.formAccepted}
              className="btn-solid"
              onClick={this.submitStep2}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    );
  }

  renderStep3() {
    return (
      <div>
        {this.state.isLoading ? (
          <div className="text-center">
            <img
              src="./icon/Spin.svg"
              alt="Loading ..."
              className="whirly-loader"
            />
          </div>
        ) : (
          <div>
            <div className="step-title">W-8Ben form submission</div>
            <hr />
            <div className="step-content center">
              <br />
              <div>Your W-8BEN form has been successfully submitted.</div>
              <br />
              <div>
                Please allow for 5-7 business days to process your application.
              </div>
              <div>
                This will not affect your ability to fund or trade on your
                offshore account.
              </div>
              <br />
              <div>
                If you have any queries, feel free to contact our support desk
                on
              </div>

              <div>
                <strong>
                  {this.state.tenantData.supportNumber} or via email{" "}
                  <a href={`mailto:${this.state.tenantData.supportEmail}`}>
                    {this.state.tenantData.supportEmail}
                  </a>
                </strong>{" "}
              </div>
              <br />
              <div>
                <a
                  id="download-link"
                  style={{ display: "none" }}
                  download="true"
                  target="_blank"
                  rel="noreferrer"
                  href="javascript:void(0);"
                >
                  Download W-8BEN form
                </a>
                <a
                  download="true"
                  href="javascript:void(0);"
                  onClick={this.getApprovedDownloadLink}
                >
                  Download W-8BEN form
                </a>
              </div>

              <br />
            </div>
          </div>
        )}
      </div>
    );
  }

  public render() {
    return (
      <div className="form-container">
        {this.state.loading ? (
          <div> loading... </div>
        ) : this.state.applicationCanceled ? (
          this.renderCancelPage()
        ) : this.state.error ? (
          this.renderError()
        ) : (
          <React.Fragment>
            <div>
              <h1>IRS W-8BEN Form</h1>
            </div>

            <div>{this.renderWizardSteps()}</div>

            <div className="form-step">{this.renderFormStep()}</div>
          </React.Fragment>
        )}
      </div>
    );
  }
}
